import { useEffect, useMemo, useState } from "react";
import api from "../../lib/api";
import TxnDialog from "./TxnDialog";
import { SYNC_LABEL, SYNC_TONE, fmtTime, rp } from "./util";

const fromServer = (t) => ({ ...t, customer_name: t.customer.name, customer_wa: t.customer.wa, sync_status: "SYNCED", _server: true });

export default function Sales({ event, txns, online, reload }) {
    const [server, setServer] = useState([]);
    const [open, setOpen] = useState(null);
    useEffect(() => {
        if (event && online) api.get("/pos/transactions", { params: { event_id: event.id }, timeout: 12000 }).then(({ data }) => setServer(data.map(fromServer))).catch(() => {});
    }, [event, online]);
    const rows = useMemo(() => {
        const ids = new Set(txns.map((t) => t.id));
        return [...txns, ...server.filter((t) => !ids.has(t.id))].sort((a, b) => b.created_at.localeCompare(a.created_at));
    }, [txns, server]);
    const total = rows.reduce((s, t) => s + t.total, 0);
    if (!event) return <p className="text-sm text-neutral-400" data-testid="pos-sales-empty">No active event.</p>;
    return (
        <div className="space-y-3" data-testid="pos-sales">
            <div className="flex flex-wrap gap-4 text-sm">
                <span data-testid="pos-sales-count"><b>{rows.length}</b> transactions</span>
                <span data-testid="pos-sales-total">Total <b>{rp(total)}</b></span>
            </div>
            <div className="overflow-x-auto rounded-md border border-mist bg-white">
                <table className="w-full min-w-[820px] text-sm">
                    <thead className="bg-ivory text-[10px] uppercase tracking-widest text-neutral-500">
                        <tr>{["Transaction No.", "Time", "Customer", "WhatsApp", "Items", "Payment", "Total", "Sync"].map((h) => <th key={h} className="px-3 py-2 text-left font-medium">{h}</th>)}</tr>
                    </thead>
                    <tbody className="divide-y divide-mist">
                        {rows.map((t) => (
                            <tr key={t.id} onClick={() => setOpen(t.id)} className="cursor-pointer hover:bg-ivory" data-testid={`pos-sale-row-${t.number}`}>
                                <td className="px-3 py-2 font-mono text-xs">{t.number}</td>
                                <td className="px-3 py-2 whitespace-nowrap">{fmtTime(t.created_at)}</td>
                                <td className="px-3 py-2">{t.customer_name}</td>
                                <td className="px-3 py-2">{t.customer_wa}</td>
                                <td className="px-3 py-2">{t.items.reduce((s, x) => s + x.qty, 0)}</td>
                                <td className="px-3 py-2">{t.payment_method}</td>
                                <td className="px-3 py-2 font-medium">{rp(t.total)}</td>
                                <td className={`px-3 py-2 text-xs ${SYNC_TONE[t.sync_status]}`} data-testid={`pos-sale-sync-${t.number}`}>{SYNC_LABEL[t.sync_status]}</td>
                            </tr>
                        ))}
                        {!rows.length && <tr><td colSpan={8} className="px-3 py-6 text-center text-neutral-400">No sales yet.</td></tr>}
                    </tbody>
                </table>
            </div>
            <TxnDialog txn={rows.find((t) => t.id === open)} reload={reload} onClose={() => setOpen(null)} />
        </div>
    );
}
